// import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Table,
//   Button,
//   Form,
//   Pagination,
//   Spinner,
//   Alert,
// } from "react-bootstrap";
// import axios from "axios";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
// } from "recharts";
// import { FaTimes } from "react-icons/fa";
// import "./Report.css";
// import { URL } from "../../../config";

// const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#845EC2"];

// const AmountRecharges = () => {
//   const token = localStorage.getItem("adminToken");

//   // data state
//   const [recharges, setRecharges] = useState([]);
//   const [filteredRecharges, setFilteredRecharges] = useState([]);

//   // ui state
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   const [viewMode, setViewMode] = useState("table"); // table | graph
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // optional details modal (same design language)
//   const [showModal, setShowModal] = useState(false);
//   const [selectedRecharge, setSelectedRecharge] = useState(null);
//   const modalRef = useRef();

//   const fetchRecharges = useCallback(async (sDate, eDate) => {
//     setLoading(true);
//     try {
//       let url = `${URL}/recharges`;
//       if (sDate && eDate) {
//         url += `?startDate=${sDate}&endDate=${eDate}`;
//       }
//       const { data } = await axios.get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setRecharges(data || []);
//       setFilteredRecharges(data || []);
//       setCurrentPage(1);
//       setError("");
//     } catch (err) {
//       console.error("Error fetching recharges:", err);
//       setError("Failed to load recharges. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   useEffect(() => {
//     fetchRecharges();
//   }, [fetchRecharges]);

//   // client-side filter
//   useEffect(() => {
//     let results = recharges;
//     if (startDate && endDate) {
//       results = recharges.filter((r) => {
//         const d = new Date(r.created_at).toISOString().split("T")[0];
//         return d >= startDate && d <= endDate;
//       });
//     }
//     setFilteredRecharges(results);
//     setCurrentPage(1);
//   }, [startDate, endDate, recharges]);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (startDate && endDate) {
//       fetchRecharges(startDate, endDate);
//     } else {
//       fetchRecharges();
//     }
//   };

//   const handleReset = () => {
//     setStartDate("");
//     setEndDate("");
//     fetchRecharges();
//   };

//   const handleOpenModal = (rc) => {
//     setSelectedRecharge(rc);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedRecharge(null);
//     document.body.style.overflow = "auto";
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const onBackdrop = (e) => {
//       if (node && e.target === node) handleCloseModal();
//     };
//     const onEsc = (e) => {
//       if (e.key === "Escape") handleCloseModal();
//     };
//     if (node) node.addEventListener("click", onBackdrop);
//     document.addEventListener("keydown", onEsc);
//     return () => {
//       if (node) node.removeEventListener("click", onBackdrop);
//       document.removeEventListener("keydown", onEsc);
//     };
//   }, []);

//   // pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredRecharges.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredRecharges.length / itemsPerPage);

//   const handlePageChange = (p) => setCurrentPage(p);

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);
//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));
//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   // helpers
//   const formatDateTime = (iso) => {
//     const d = new Date(iso);
//     const dateStr = d.toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" });
//     const [month, day, year] = dateStr.replace(",", "").split(" ");
//     const datePart = `${day}-${month}-${year}`;
//     const timeStr = d
//       .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true })
//       .toLowerCase();
//     return `${datePart}, ${timeStr}`;
//   };

//   const monthKey = (date) => {
//     const d = new Date(date);
//     const y = d.getFullYear();
//     const m = d.toLocaleString("en-US", { month: "short" }); // Jan, Feb...
//     return `${m} ${y}`;
//   };

//   // stats
//   const totalAmount = filteredRecharges.reduce((acc, r) => acc + (Number(r.amount) || 0), 0);
//   const totalCount = filteredRecharges.length;

//   // charts: month-wise totals
//   const monthMap = useMemo(() => {
//     const map = {};
//     filteredRecharges.forEach((r) => {
//       const key = monthKey(r.created_at);
//       const amt = Number(r.amount) || 0;
//       map[key] = (map[key] || 0) + amt;
//     });
//     // sort by date
//     return Object.entries(map)
//       .map(([k, amount]) => {
//         // convert "Jan 2025" -> Date for ordering
//         const [monStr, yearStr] = k.split(" ");
//         const dt = new Date(`${monStr} 1, ${yearStr}`);
//         return { k, amount, dt };
//       })
//       .sort((a, b) => a.dt - b.dt)
//       .map(({ k, amount }) => ({ month: k, amount }));
//   }, [filteredRecharges]);

//   // charts: amount by payment method
//   const methodChart = useMemo(() => {
//     const byMethod = {};
//     filteredRecharges.forEach((r) => {
//       const method = r.paymentMethod || r.PaymentMethod || "Unknown";
//       const amt = Number(r.amount) || 0;
//       byMethod[method] = (byMethod[method] || 0) + amt;
//     });
//     return Object.entries(byMethod).map(([method, amount]) => ({ method, amount }));
//   }, [filteredRecharges]);

//   // modal content
//   const renderDetails = () => {
//     if (!selectedRecharge) return null;
//     const { Servitor, amount, paymentMethod, PaymentMethod, created_at, tranId, status } = selectedRecharge;
//     const servName = Servitor ? `${Servitor.FirstName} ${Servitor.LastName}` : "N/A";
//     const servId = Servitor?.Id || "N/A";
//     const mobile = Servitor?.mobile || "N/A";
//     const pMethod = paymentMethod || PaymentMethod || "N/A";

//     return (
//       <div className="adminReportdetails-modal">
//         <div className="adminReportdetails-modal-header">
//           <button className="adminReportdetails-modal-close" onClick={handleCloseModal}>
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminReportdetails-service-icon">
//               <i className="fas fa-wallet" style={{ color: "#f59e0b" }} />
//             </div>
//             <div>
//               <h2 className="adminReportdetails-modal-title">Recharge Details</h2>
//               <p className="adminReportdetails-modal-subtitle">Servitor Recharge • {pMethod}</p>
//             </div>
//           </div>
//         </div>

//         <div className="adminReportdetails-modal-body">
//           <div className="adminReportdetails-summary-cards">
//             <div className="adminReportdetails-summary-card adminReportdetails-amount-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Amount</p>
//                 <p className="adminReportdetails-price-value">৳{(Number(amount) || 0).toFixed(2)}</p>
//               </div>
//             </div>
//             <div className="adminReportdetails-summary-card adminReportdetails-commission-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Payment Method</p>
//                 <p className="adminReportdetails-detail-value">{pMethod}</p>
//               </div>
//             </div>
//             <div className="adminReportdetails-summary-card adminReportdetails-date-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Date & Time</p>
//                 <p className="adminReportdetails-detail-value">{formatDateTime(created_at)}</p>
//               </div>
//             </div>
//           </div>

//           <div className="adminReportdetails-detail-card">
//             <h3 className="adminReportdetails-detail-title">
//               <i className="fas fa-user-tie" style={{ marginRight: 8, color: "#f59e0b" }} />
//               Servitor
//             </h3>
//             <div className="adminReportdetails-detail-grid">
//               <div>
//                 <p className="adminReportdetails-detail-text">Name</p>
//                 <p className="adminReportdetails-detail-value">{servName}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Servitor ID</p>
//                 <p className="adminReportdetails-detail-value">{servId}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Mobile</p>
//                 <p className="adminReportdetails-detail-value">{mobile}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Status</p>
//                 <p className="adminReportdetails-detail-value">{status || "N/A"}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Transaction ID</p>
//                 <p className="adminReportdetails-detail-value">{tranId || "N/A"}</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="adminReportdetails-modal-footer">
//           <div className="adminReportdetails-footer-buttons">
//             <button
//               className="adminReportdetails-footer-btn adminReportdetails-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaTimes /> Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminReportdetails-container">
//       <Card className="adminReportdetails-card">
//         <Card.Header className="adminReportdetails-header">
//           <h4 className="adminReportdetails-title">Recharge Amount Report</h4>
//         </Card.Header>
//         <Card.Body>
//           {/* Stats */}
//           <div className="adminReportdetails-stats-container">
//             <div className="adminReportdetails-stats-card adminReportdetails-green">
//               <div className="adminReportdetails-stats-icon">
//                 <i className="fas fa-wallet"></i>
//               </div>
//               <div className="adminReportdetails-stats-title">TOTAL RECHARGE AMOUNT</div>
//               <div className="adminReportdetails-stats-value">{totalAmount.toFixed(2)}৳</div>
//             </div>
//             <div className="adminReportdetails-stats-card adminReportdetails-blue">
//               <div className="adminReportdetails-stats-icon">
//                 <i className="fas fa-battery-three-quarters"></i>
//               </div>
//               <div className="adminReportdetails-stats-title">RECHARGE COUNT</div>
//               <div className="adminReportdetails-stats-value">{totalCount}</div>
//             </div>
//           </div>

//           {/* Date Filter */}
//           <Form onSubmit={handleSearch} className="mb-4">
//             <Row className="align-items-end">
//               <Col md={4} className="mb-3">
//                 <Form.Group controlId="startDate">
//                   <Form.Label>Start Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     className="adminReportdetails-search"
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-3">
//                 <Form.Group controlId="endDate">
//                   <Form.Label>End Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     className="adminReportdetails-search"
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-3 d-flex">
//                 <div className="ms-auto">
//                   <Button variant="primary" type="submit" className="me-2 adminReportdetails-filter-btn">
//                     Search
//                   </Button>
//                   <Button
//                     variant="outline-primary"
//                     onClick={handleReset}
//                     className="adminReportdetails-filter-btn"
//                   >
//                     Reset
//                   </Button>
//                 </div>
//               </Col>
//             </Row>
//           </Form>

//           {/* View toggle */}
//           <div className="adminReportdetails-filter-container">
//             <div className="adminReportdetails-service-filters">
//               <Button
//                 variant={viewMode === "table" ? "primary" : "outline-primary"}
//                 className="adminReportdetails-filter-btn"
//                 onClick={() => setViewMode("table")}
//               >
//                 Table View
//               </Button>
//               <Button
//                 variant={viewMode === "graph" ? "primary" : "outline-primary"}
//                 className="adminReportdetails-filter-btn"
//                 onClick={() => setViewMode("graph")}
//               >
//                 Graph View
//               </Button>
//             </div>
//           </div>

//           {/* Content */}
//           {loading && (
//             <div className="text-center">
//               <Spinner animation="border" />
//             </div>
//           )}
//           {error && (
//             <Alert variant="danger" className="adminReportdetails-error">
//               {error}
//             </Alert>
//           )}
//           {!loading && !error && filteredRecharges.length === 0 && (
//             <p className="adminReportdetails-empty-text">No recharges found.</p>
//           )}

//           {!loading && !error && filteredRecharges.length > 0 && (
//             <>
//               {viewMode === "table" ? (
//                 <>
//                   <Table striped bordered hover responsive className="adminReportdetails-table">
//                     <thead>
//                       <tr>
//                         <th>#</th>
//                         <th>Servitor Name</th>
//                         <th>Servitor ID</th>
//                         <th>Mobile</th>
//                         <th>Payment Method</th>
//                         <th>Amount</th>
//                         <th>Date</th>
//                         <th>Details</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {currentItems.map((rc, idx) => {
//                         const s = rc.Servitor;
//                         const name = s ? `${s.FirstName} ${s.LastName}` : "N/A";
//                         const method = rc.paymentMethod || rc.PaymentMethod || "N/A";
//                         const amount = Number(rc.amount) || 0;
//                         return (
//                           <tr key={rc.Id || `${method}-${rc.created_at}-${idx}`}>
//                             <td>{idx + 1 + indexOfFirstItem}</td>
//                             <td>{name}</td>
//                             <td>{s?.Id || "N/A"}</td>
//                             <td>{s?.mobile || "N/A"}</td>
//                             <td>{method}</td>
//                             <td>{amount.toFixed(2)}৳</td>
//                             <td>{formatDateTime(rc.created_at)}</td>
//                             <td>
//                               <Button
//                                 size="sm"
//                                 variant="outline-primary"
//                                 className="adminReportdetails-filter-btn"
//                                 onClick={() => handleOpenModal(rc)}
//                               >
//                                 View
//                               </Button>
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </Table>

//                   <Pagination>
//                     <Pagination.First
//                       onClick={() => handlePageChange(1)}
//                       disabled={currentPage === 1}
//                     />
//                     <Pagination.Prev
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                     />
//                     {getPageItems(totalPages, currentPage).map((item, idx) =>
//                       item === "start-ellipsis" || item === "end-ellipsis" ? (
//                         <Pagination.Ellipsis key={item + idx} disabled />
//                       ) : (
//                         <Pagination.Item
//                           key={item}
//                           active={item === currentPage}
//                           onClick={() => handlePageChange(item)}
//                         >
//                           {item}
//                         </Pagination.Item>
//                       )
//                     )}
//                     <Pagination.Next
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                     />
//                     <Pagination.Last
//                       onClick={() => handlePageChange(totalPages)}
//                       disabled={currentPage === totalPages}
//                     />
//                   </Pagination>
//                   <div className="mt-2 text-muted adminReportdetails-results-text">
//                     Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredRecharges.length)} of {filteredRecharges.length} results
//                   </div>
//                 </>
//               ) : (
//                 <Row>
//                   <Col md={6} className="mb-4">
//                     <Card className="adminReportdetails-chart-card">
//                       <Card.Body>
//                         <h5 className="adminReportdetails-chart-title">Recharge Amount — Month wise</h5>
//                         <div style={{ width: "100%", height: 320 }}>
//                           <ResponsiveContainer>
//                             <BarChart data={monthMap}>
//                               <XAxis dataKey="month" />
//                               <YAxis />
//                               <Tooltip />
//                               <Legend />
//                               <Bar dataKey="amount" name="Amount" fill="#10b981" />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>

//                   <Col md={6} className="mb-4">
//                     <Card className="adminReportdetails-chart-card">
//                       <Card.Body>
//                         <h5 className="adminReportdetails-chart-title">Amount by Payment Method</h5>
//                         <div style={{ width: "100%", height: 320 }}>
//                           <ResponsiveContainer>
//                             <PieChart>
//                               <Pie
//                                 data={methodChart}
//                                 dataKey="amount"
//                                 nameKey="method"
//                                 outerRadius={110}
//                                 label
//                               >
//                                 {methodChart.map((entry, index) => (
//                                   <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                                 ))}
//                               </Pie>
//                               <Tooltip />
//                               <Legend />
//                             </PieChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                 </Row>
//               )}
//             </>
//           )}
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div className="adminReportdetails-modal-backdrop" ref={modalRef}>
//           {renderDetails()}
//         </div>
//       )}
//     </Container>
//   );
// };

// export default AmountRecharges;









// import React, { useCallback, useEffect, useRef, useState } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Table,
//   Button,
//   Form,
//   Pagination,
//   Spinner,
//   Alert,
// } from "react-bootstrap";
// import axios from "axios";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
// } from "recharts";
// import { FaTimes } from "react-icons/fa";
// import "./Report.css";
// import { URL } from "../../../config";

// const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#845EC2"];
// const DEFAULT_LIMIT = 10;

// const AmountRecharges = () => {
//   const token = localStorage.getItem("adminToken");

//   // data state (page slice)
//   const [recharges, setRecharges] = useState([]);

//   // ui state
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // filters
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [mobileQuery, setMobileQuery] = useState("");

//   // view + pagination
//   const [viewMode, setViewMode] = useState("table"); // table | graph
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: DEFAULT_LIMIT,
//     total: 0,
//     totalPages: 1,
//   });

//   // summary + charts from backend
//   const [summary, setSummary] = useState({
//     totalAmount: 0,
//     totalCount: 0,
//   });
//   const [byMonthChart, setByMonthChart] = useState([]);
//   const [byMethodChart, setByMethodChart] = useState([]);

//   // details modal
//   const [showModal, setShowModal] = useState(false);
//   const [selectedRecharge, setSelectedRecharge] = useState(null);
//   const modalRef = useRef();

//   const fetchRecharges = useCallback(
//     async (pageOverride) => {
//       setLoading(true);
//       try {
//         const page = pageOverride ?? meta.page;
//         const { data } = await axios.get(`${URL}/recharges`, {
//           headers: token ? { Authorization: `Bearer ${token}` } : undefined,
//           params: {
//             page,
//             limit: meta.limit,
//             startDate: startDate || undefined,
//             endDate: endDate || undefined,
//             mobile: mobileQuery || undefined, // NEW: mobile search
//           },
//         });

//         setRecharges(Array.isArray(data?.data) ? data.data : []);
//         setMeta((m) => ({
//           ...m,
//           page: data?.meta?.page || page,
//           limit: data?.meta?.limit || m.limit,
//           total: data?.meta?.total || 0,
//           totalPages: data?.meta?.totalPages || 1,
//         }));
//         setSummary({
//           totalAmount: Number(data?.summary?.totalAmount || 0),
//           totalCount: Number(data?.summary?.totalCount || 0),
//         });
//         setByMonthChart(Array.isArray(data?.charts?.byMonth) ? data.charts.byMonth : []);
//         setByMethodChart(Array.isArray(data?.charts?.byMethod) ? data.charts.byMethod : []);
//         setError("");
//       } catch (err) {
//         console.error("Error fetching recharges:", err);
//         setError("Failed to load recharges. Please try again.");
//         setRecharges([]);
//         setSummary({ totalAmount: 0, totalCount: 0 });
//         setByMonthChart([]);
//         setByMethodChart([]);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [token, meta.page, meta.limit, startDate, endDate, mobileQuery]
//   );

//   useEffect(() => {
//     fetchRecharges();
//   }, [fetchRecharges]);

//   const handleOpenModal = (rc) => {
//     setSelectedRecharge(rc);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedRecharge(null);
//     document.body.style.overflow = "auto";
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const onBackdrop = (e) => node && e.target === node && handleCloseModal();
//     const onEsc = (e) => e.key === "Escape" && handleCloseModal();
//     if (node) node.addEventListener("click", onBackdrop);
//     document.addEventListener("keydown", onEsc);
//     return () => {
//       if (node) node.removeEventListener("click", onBackdrop);
//       document.removeEventListener("keydown", onEsc);
//     };
//   }, []);

//   // manual search submit (keeps behavior predictable)
//   const handleSearch = (e) => {
//     e.preventDefault();
//     setMeta((m) => ({ ...m, page: 1 }));
//     fetchRecharges(1);
//   };

//   const handleReset = () => {
//     setStartDate("");
//     setEndDate("");
//     setMobileQuery("");
//     setMeta((m) => ({ ...m, page: 1 }));
//     fetchRecharges(1);
//   };

//   // pagination UI helpers
//   const handlePageChange = (pageNumber) => {
//     setMeta((m) => ({ ...m, page: pageNumber }));
//     fetchRecharges(pageNumber);
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);
//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));
//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   // helpers
//   const formatDateTime = (iso) => {
//     const d = new Date(iso);
//     const dateStr = d.toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" });
//     const [month, day, year] = dateStr.replace(",", "").split(" ");
//     const datePart = `${day}-${month}-${year}`;
//     const timeStr = d
//       .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true })
//       .toLowerCase();
//     return `${datePart}, ${timeStr}`;
//   };

//   // modal content
//   const renderDetails = () => {
//     if (!selectedRecharge) return null;
//     const { Servitor, amount, paymentMethod, PaymentMethod, created_at, tranId, status } = selectedRecharge;
//     const servName = Servitor ? `${Servitor.FirstName} ${Servitor.LastName}` : "N/A";
//     const servId = Servitor?.Id || "N/A";
//     const mobile = Servitor?.mobile || "N/A";
//     const pMethod = paymentMethod || PaymentMethod || "N/A";

//     return (
//       <div className="adminReportdetails-modal">
//         <div className="adminReportdetails-modal-header">
//           <button className="adminReportdetails-modal-close" onClick={handleCloseModal}>
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminReportdetails-service-icon">
//               <i className="fas fa-wallet" style={{ color: "#f59e0b" }} />
//             </div>
//             <div>
//               <h2 className="adminReportdetails-modal-title">Recharge Details</h2>
//               <p className="adminReportdetails-modal-subtitle">Servitor Recharge • {pMethod}</p>
//             </div>
//           </div>
//         </div>

//         <div className="adminReportdetails-modal-body">
//           <div className="adminReportdetails-summary-cards">
//             <div className="adminReportdetails-summary-card adminReportdetails-amount-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Amount</p>
//                 <p className="adminReportdetails-price-value">৳{(Number(amount) || 0).toFixed(2)}</p>
//               </div>
//             </div>
//             <div className="adminReportdetails-summary-card adminReportdetails-commission-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Payment Method</p>
//                 <p className="adminReportdetails-detail-value">{pMethod}</p>
//               </div>
//             </div>
//             <div className="adminReportdetails-summary-card adminReportdetails-date-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Date & Time</p>
//                 <p className="adminReportdetails-detail-value">{formatDateTime(created_at)}</p>
//               </div>
//             </div>
//           </div>

//           <div className="adminReportdetails-detail-card">
//             <h3 className="adminReportdetails-detail-title">
//               <i className="fas fa-user-tie" style={{ marginRight: 8, color: "#f59e0b" }} />
//               Servitor
//             </h3>
//             <div className="adminReportdetails-detail-grid">
//               <div>
//                 <p className="adminReportdetails-detail-text">Name</p>
//                 <p className="adminReportdetails-detail-value">{servName}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Servitor ID</p>
//                 <p className="adminReportdetails-detail-value">{servId}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Mobile</p>
//                 <p className="adminReportdetails-detail-value">{mobile}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Status</p>
//                 <p className="adminReportdetails-detail-value">{status || "N/A"}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Transaction ID</p>
//                 <p className="adminReportdetails-detail-value">{tranId || "N/A"}</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="adminReportdetails-modal-footer">
//           <div className="adminReportdetails-footer-buttons">
//             <button
//               className="adminReportdetails-footer-btn adminReportdetails-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaTimes /> Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminReportdetails-container">
//       <Card className="adminReportdetails-card">
//         <Card.Header className="adminReportdetails-header">
//           <h4 className="adminReportdetails-title">Recharge Amount Report</h4>
//         </Card.Header>
//         <Card.Body>
//           {/* Stats (from backend) */}
//           <div className="adminReportdetails-stats-container">
//             <div className="adminReportdetails-stats-card adminReportdetails-green">
//               <div className="adminReportdetails-stats-icon">
//                 <i className="fas fa-wallet"></i>
//               </div>
//               <div className="adminReportdetails-stats-title">TOTAL RECHARGE AMOUNT</div>
//               <div className="adminReportdetails-stats-value">{summary.totalAmount.toFixed(2)}৳</div>
//             </div>
//             <div className="adminReportdetails-stats-card adminReportdetails-blue">
//               <div className="adminReportdetails-stats-icon">
//                 <i className="fas fa-battery-three-quarters"></i>
//               </div>
//               <div className="adminReportdetails-stats-title">RECHARGE COUNT</div>
//               <div className="adminReportdetails-stats-value">{summary.totalCount}</div>
//             </div>
//           </div>

//           {/* Filters: Date + Mobile */}
//           <Form onSubmit={handleSearch} className="mb-4">
//             <Row className="align-items-end">
//               <Col md={3} className="mb-3">
//                 <Form.Group controlId="startDate">
//                   <Form.Label>Start Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     className="adminReportdetails-search"
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={3} className="mb-3">
//                 <Form.Group controlId="endDate">
//                   <Form.Label>End Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     className="adminReportdetails-search"
//                   />
//                 </Form.Group>
//               </Col>

//               {/* NEW: Mobile search */}
//               <Col md={3} className="mb-3">
//                 <Form.Group controlId="mobile">
//                   <Form.Label>Mobile Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Enter mobile number"
//                     value={mobileQuery}
//                     onChange={(e) => setMobileQuery(e.target.value)}
//                     className="adminReportdetails-search"
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={3} className="mb-3 d-flex">
//                 <div className="ms-auto">
//                   <Button variant="primary" type="submit" className="me-2 adminReportdetails-filter-btn">
//                     Search
//                   </Button>
//                   <Button
//                     variant="outline-primary"
//                     onClick={handleReset}
//                     className="adminReportdetails-filter-btn"
//                   >
//                     Reset
//                   </Button>
//                 </div>
//               </Col>
//             </Row>
//           </Form>

//           {/* View toggle */}
//           <div className="adminReportdetails-filter-container">
//             <div className="adminReportdetails-service-filters">
//               <Button
//                 variant={viewMode === "table" ? "primary" : "outline-primary"}
//                 className="adminReportdetails-filter-btn"
//                 onClick={() => setViewMode("table")}
//               >
//                 Table View
//               </Button>
//               <Button
//                 variant={viewMode === "graph" ? "primary" : "outline-primary"}
//                 className="adminReportdetails-filter-btn"
//                 onClick={() => setViewMode("graph")}
//               >
//                 Graph View
//               </Button>
//             </div>
//           </div>

//           {/* Content */}
//           {loading && (
//             <div className="text-center">
//               <Spinner animation="border" />
//             </div>
//           )}
//           {error && (
//             <Alert variant="danger" className="adminReportdetails-error">
//               {error}
//             </Alert>
//           )}
//           {!loading && !error && summary.totalCount === 0 && (
//             <p className="adminReportdetails-empty-text">No recharges found.</p>
//           )}

//           {!loading && !error && summary.totalCount > 0 && (
//             <>
//               {viewMode === "table" ? (
//                 <>
//                   <Table striped bordered hover responsive className="adminReportdetails-table">
//                     <thead>
//                       <tr>
//                         <th>#</th>
//                         <th>Servitor Name</th>
//                         <th>Servitor ID</th>
//                         <th>Mobile</th>
//                         <th>Payment Method</th>
//                         <th>Amount</th>
//                         <th>Date</th>
//                         <th>Details</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {recharges.map((rc, idx) => {
//                         const s = rc.Servitor;
//                         const name = s ? `${s.FirstName} ${s.LastName}` : "N/A";
//                         const method = rc.paymentMethod || rc.PaymentMethod || "N/A";
//                         const amount = Number(rc.amount) || 0;
//                         return (
//                           <tr key={rc.Id || `${method}-${rc.created_at}-${idx}`}>
//                             <td>{idx + 1 + (meta.page - 1) * meta.limit}</td>
//                             <td>{name}</td>
//                             <td>{s?.Id || "N/A"}</td>
//                             <td>{s?.mobile || "N/A"}</td>
//                             <td>{method}</td>
//                             <td>{amount.toFixed(2)}৳</td>
//                             <td>{formatDateTime(rc.created_at)}</td>
//                             <td>
//                               <Button
//                                 size="sm"
//                                 variant="outline-primary"
//                                 className="adminReportdetails-filter-btn"
//                                 onClick={() => handleOpenModal(rc)}
//                               >
//                                 View
//                               </Button>
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </Table>

//                   {/* Server-side pagination controls */}
//                   <Pagination>
//                     <Pagination.First onClick={() => handlePageChange(1)} disabled={meta.page === 1} />
//                     <Pagination.Prev
//                       onClick={() => handlePageChange(meta.page - 1)}
//                       disabled={meta.page === 1}
//                     />
//                     {getPageItems(meta.totalPages, meta.page).map((item, idx) =>
//                       item === "start-ellipsis" || item === "end-ellipsis" ? (
//                         <Pagination.Ellipsis key={item + idx} disabled />
//                       ) : (
//                         <Pagination.Item
//                           key={item}
//                           active={item === meta.page}
//                           onClick={() => handlePageChange(item)}
//                         >
//                           {item}
//                         </Pagination.Item>
//                       )
//                     )}
//                     <Pagination.Next
//                       onClick={() => handlePageChange(meta.page + 1)}
//                       disabled={meta.page === meta.totalPages}
//                     />
//                     <Pagination.Last
//                       onClick={() => handlePageChange(meta.totalPages)}
//                       disabled={meta.page === meta.totalPages}
//                     />
//                   </Pagination>
//                   <div className="mt-2 text-muted adminReportdetails-results-text">
//                     Showing {(meta.page - 1) * meta.limit + 1} to{" "}
//                     {Math.min(meta.page * meta.limit, summary.totalCount)} of {summary.totalCount} results
//                   </div>
//                 </>
//               ) : (
//                 <Row>
//                   <Col md={6} className="mb-4">
//                     <Card className="adminReportdetails-chart-card">
//                       <Card.Body>
//                         <h5 className="adminReportdetails-chart-title">Recharge Amount — Month wise</h5>
//                         <div style={{ width: "100%", height: 320 }}>
//                           <ResponsiveContainer>
//                             <BarChart data={byMonthChart}>
//                               <XAxis dataKey="month" />
//                               <YAxis />
//                               <Tooltip />
//                               <Legend />
//                               <Bar dataKey="amount" name="Amount" fill="#10b981" />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>

//                   <Col md={6} className="mb-4">
//                     <Card className="adminReportdetails-chart-card">
//                       <Card.Body>
//                         <h5 className="adminReportdetails-chart-title">Amount by Payment Method</h5>
//                         <div style={{ width: "100%", height: 320 }}>
//                           <ResponsiveContainer>
//                             <PieChart>
//                               <Pie data={byMethodChart} dataKey="amount" nameKey="method" outerRadius={110} label>
//                                 {byMethodChart.map((entry, index) => (
//                                   <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                                 ))}
//                               </Pie>
//                               <Tooltip />
//                               <Legend />
//                             </PieChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                 </Row>
//               )}
//             </>
//           )}
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div className="adminReportdetails-modal-backdrop" ref={modalRef}>
//           {renderDetails()}
//         </div>
//       )}
//     </Container>
//   );
// };

// export default AmountRecharges;


// ********* Upper code is all okay for Payment gateway for view (4-Dec-2025) ******** //


// ******** Here new updated for handle Recharge and after check make approve by admin (This is for temporary) (4-Dec-2025) ******** //
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Form,
  Pagination,
  Spinner,
  Alert,
} from "react-bootstrap";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import { FaTimes, FaEye, FaCheck, FaTimesCircle } from "react-icons/fa"; // ✅ UPDATED: more icons
import "./Report.css";
import { URL } from "../../../config";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#845EC2"];
const DEFAULT_LIMIT = 10;

const AmountRecharges = () => {
  const token = localStorage.getItem("adminToken");

  // data state (page slice)
  const [recharges, setRecharges] = useState([]);

  // ui state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // filters
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [mobileQuery, setMobileQuery] = useState("");


  // confirm modal for approve / reject
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmType, setConfirmType] = useState(null); // 'approve' | 'reject'
  const [confirmRecharge, setConfirmRecharge] = useState(null);


  // view + pagination
  const [viewMode, setViewMode] = useState("table"); // table | graph
  const [meta, setMeta] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    total: 0,
    totalPages: 1,
  });

  // summary + charts from backend
  const [summary, setSummary] = useState({
    totalAmount: 0,
    totalCount: 0,
  });
  const [byMonthChart, setByMonthChart] = useState([]);
  const [byMethodChart, setByMethodChart] = useState([]);

  // details modal
  const [showModal, setShowModal] = useState(false);
  const [selectedRecharge, setSelectedRecharge] = useState(null);
  const modalRef = useRef();

  // which recharge is being approved/rejected
  const [updatingId, setUpdatingId] = useState(null);

  const fetchRecharges = useCallback(
    async (pageOverride) => {
      setLoading(true);
      try {
        const page = pageOverride ?? meta.page;
        const { data } = await axios.get(`${URL}/recharges`, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          params: {
            page,
            limit: meta.limit,
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            mobile: mobileQuery || undefined,
          },
        });

        setRecharges(Array.isArray(data?.data) ? data.data : []);
        setMeta((m) => ({
          ...m,
          page: data?.meta?.page || page,
          limit: data?.meta?.limit || m.limit,
          total: data?.meta?.total || 0,
          totalPages: data?.meta?.totalPages || 1,
        }));
        setSummary({
          totalAmount: Number(data?.summary?.totalAmount || 0),
          totalCount: Number(data?.summary?.totalCount || 0),
        });
        setByMonthChart(
          Array.isArray(data?.charts?.byMonth) ? data.charts.byMonth : []
        );
        setByMethodChart(
          Array.isArray(data?.charts?.byMethod) ? data.charts.byMethod : []
        );
        setError("");
      } catch (err) {
        console.error("Error fetching recharges:", err);
        setError("Failed to load recharges. Please try again.");
        setRecharges([]);
        setSummary({ totalAmount: 0, totalCount: 0 });
        setByMonthChart([]);
        setByMethodChart([]);
      } finally {
        setLoading(false);
      }
    },
    [token, meta.page, meta.limit, startDate, endDate, mobileQuery]
  );

  useEffect(() => {
    fetchRecharges();
  }, [fetchRecharges]);

  const handleOpenModal = (rc) => {
    setSelectedRecharge(rc);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRecharge(null);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const node = modalRef.current;
    const onBackdrop = (e) => node && e.target === node && handleCloseModal();
    const onEsc = (e) => e.key === "Escape" && handleCloseModal();
    if (node) node.addEventListener("click", onBackdrop);
    document.addEventListener("keydown", onEsc);
    return () => {
      if (node) node.removeEventListener("click", onBackdrop);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  // search
  const handleSearch = (e) => {
    e.preventDefault();
    setMeta((m) => ({ ...m, page: 1 }));
    fetchRecharges(1);
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setMobileQuery("");
    setMeta((m) => ({ ...m, page: 1 }));
    fetchRecharges(1);
  };

  // pagination
  const handlePageChange = (pageNumber) => {
    setMeta((m) => ({ ...m, page: pageNumber }));
    fetchRecharges(pageNumber);
  };

  const getPageItems = (total, current, maxButtons = 7) => {
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end = Math.min(total - 1, current + siblings);
    if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1))
      start = Math.max(2, total - (maxButtons - 2));
    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  // format date
  const formatDateTime = (iso) => {
    const d = new Date(iso);
    const dateStr = d.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const [month, day, year] = dateStr.replace(",", "").split(" ");
    const datePart = `${day}-${month}-${year}`;
    const timeStr = d
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .toLowerCase();
    return `${datePart}, ${timeStr}`;
  };

  // Approve / Reject
  // const handleUpdateStatus = async (id, newStatus) => {
  //   if (
  //     !window.confirm(
  //       `Are you sure you want to mark this recharge as ${newStatus}?`
  //     )
  //   ) {
  //     return;
  //   }

  //   try {
  //     setUpdatingId(id);
  //     await axios.patch(
  //       `${URL}/recharges/${id}/status`,
  //       { status: newStatus },
  //       {
  //         headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  //       }
  //     );
  //     await fetchRecharges(meta.page);
  //   } catch (err) {
  //     console.error("Error updating recharge status:", err);
  //     setError("Failed to update recharge status. Please try again.");
  //   } finally {
  //     setUpdatingId(null);
  //   }
  // };


  const handleUpdateStatus = async (id, newStatus) => {
    try {
      setUpdatingId(id);
      await axios.patch(
        `${URL}/recharges/${id}/status`,
        { status: newStatus },
        {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        }
      );
      await fetchRecharges(meta.page);
    } catch (err) {
      console.error("Error updating recharge status:", err);
      setError("Failed to update recharge status. Please try again.");
    } finally {
      setUpdatingId(null);
    }
  };


    const openConfirmModal = (recharge, type) => {
    setConfirmRecharge(recharge);
    setConfirmType(type); // 'approve' or 'reject'
    setConfirmOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeConfirmModal = () => {
    setConfirmOpen(false);
    setConfirmRecharge(null);
    setConfirmType(null);
    document.body.style.overflow = "auto";
  };

  const handleConfirmYes = async () => {
    if (!confirmRecharge || !confirmType) return;
    const status = confirmType === "approve" ? "VALID" : "FAILED";
    await handleUpdateStatus(confirmRecharge.Id, status);
    closeConfirmModal();
  };


  // modal content
  const renderDetails = () => {
    if (!selectedRecharge) return null;
    const {
      Servitor,
      amount,
      paymentMethod,
      PaymentMethod,
      created_at,
      tranId,
      status,
      senderMobile,
      senderTrxId,
      verifiedByAdminId,
      verifiedAt,
      note,
    } = selectedRecharge;

    const servName = Servitor
      ? `${Servitor.FirstName} ${Servitor.LastName}`
      : "N/A";
    const servId = Servitor?.Id || "N/A";
    const mobile = Servitor?.mobile || "N/A";
    const pMethod = paymentMethod || PaymentMethod || "N/A";

    return (
      <div className="adminReportdetails-modal">
        <div className="adminReportdetails-modal-header">
          <button
            className="adminReportdetails-modal-close"
            onClick={handleCloseModal}
          >
            <FaTimes size={20} />
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div className="adminReportdetails-service-icon">
              <i className="fas fa-wallet" style={{ color: "#f59e0b" }} />
            </div>
            <div>
              <h2 className="adminReportdetails-modal-title">
                Recharge Details
              </h2>
              <p className="adminReportdetails-modal-subtitle">
                Servitor Recharge • {pMethod} • {status || "N/A"}
              </p>
            </div>
          </div>
        </div>

        <div className="adminReportdetails-modal-body">
          <div className="adminReportdetails-summary-cards">
            <div className="adminReportdetails-summary-card adminReportdetails-amount-card">
              <div>
                <p className="adminReportdetails-detail-text">Amount</p>
                <p className="adminReportdetails-price-value">
                  ৳{(Number(amount) || 0).toFixed(2)}
                </p>
              </div>
            </div>
            <div className="adminReportdetails-summary-card adminReportdetails-commission-card">
              <div>
                <p className="adminReportdetails-detail-text">
                  Payment Method
                </p>
                <p className="adminReportdetails-detail-value">{pMethod}</p>
              </div>
            </div>
            <div className="adminReportdetails-summary-card adminReportdetails-date-card">
              <div>
                <p className="adminReportdetails-detail-text">Date &amp; Time</p>
                <p className="adminReportdetails-detail-value">
                  {formatDateTime(created_at)}
                </p>
              </div>
            </div>
          </div>

          <div className="adminReportdetails-detail-card">
            <h3 className="adminReportdetails-detail-title">
              <i
                className="fas fa-user-tie"
                style={{ marginRight: 8, color: "#f59e0b" }}
              />
              Servitor
            </h3>
            <div className="adminReportdetails-detail-grid">
              <div>
                <p className="adminReportdetails-detail-text">Name</p>
                <p className="adminReportdetails-detail-value">{servName}</p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">Servitor ID</p>
                <p className="adminReportdetails-detail-value">{servId}</p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">Mobile</p>
                <p className="adminReportdetails-detail-value">{mobile}</p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">Status</p>
                <p className="adminReportdetails-detail-value">
                  {status || "N/A"}
                </p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">
                  System Transaction ID
                </p>
                <p className="adminReportdetails-detail-value">
                  {tranId || "N/A"}
                </p>
              </div>

              <div>
                <p className="adminReportdetails-detail-text">
                  Sender Mobile (bKash)
                </p>
                <p className="adminReportdetails-detail-value">
                  {senderMobile || "N/A"}
                </p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">
                  Sender Trx ID (User)
                </p>
                <p className="adminReportdetails-detail-value">
                  {senderTrxId || "N/A"}
                </p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">Verified By</p>
                <p className="adminReportdetails-detail-value">
                  {verifiedByAdminId ? `Admin #${verifiedByAdminId}` : "N/A"}
                </p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">
                  Verified At (Admin)
                </p>
                <p className="adminReportdetails-detail-value">
                  {verifiedAt ? formatDateTime(verifiedAt) : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="adminReportdetails-detail-card">
            <h3 className="adminReportdetails-detail-title">Note</h3>
            <p className="adminReportdetails-detail-value">
              {note || "No note provided."}
            </p>
          </div>
        </div>

        <div className="adminReportdetails-modal-footer">
          <div className="adminReportdetails-footer-buttons">
            <button
              className="adminReportdetails-footer-btn adminReportdetails-footer-btn-close"
              onClick={handleCloseModal}
            >
              <FaTimes /> Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container fluid className="adminReportdetails-container">
      <Card className="adminReportdetails-card">
        <Card.Header className="adminReportdetails-header">
          <h4 className="adminReportdetails-title">Recharge Amount Report</h4>
        </Card.Header>
        <Card.Body>
          {/* stats */}
          <div className="adminReportdetails-stats-container">
            <div className="adminReportdetails-stats-card adminReportdetails-green">
              <div className="adminReportdetails-stats-icon">
                <i className="fas fa-wallet"></i>
              </div>
              <div className="adminReportdetails-stats-title">
                TOTAL RECHARGE AMOUNT
              </div>
              <div className="adminReportdetails-stats-value">
                {summary.totalAmount.toFixed(2)}৳
              </div>
            </div>
            <div className="adminReportdetails-stats-card adminReportdetails-blue">
              <div className="adminReportdetails-stats-icon">
                <i className="fas fa-battery-three-quarters"></i>
              </div>
              <div className="adminReportdetails-stats-title">
                RECHARGE COUNT
              </div>
              <div className="adminReportdetails-stats-value">
                {summary.totalCount}
              </div>
            </div>
          </div>

          {/* filters */}
          <Form onSubmit={handleSearch} className="mb-4">
            <Row className="align-items-end">
              <Col md={3} className="mb-3">
                <Form.Group controlId="startDate">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="adminReportdetails-search"
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="endDate">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="adminReportdetails-search"
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="mobile">
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter mobile number"
                    value={mobileQuery}
                    onChange={(e) => setMobileQuery(e.target.value)}
                    className="adminReportdetails-search"
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3 d-flex">
                <div className="ms-auto">
                  <Button
                    variant="primary"
                    type="submit"
                    className="me-2 adminReportdetails-filter-btn"
                  >
                    Search
                  </Button>
                  <Button
                    variant="outline-primary"
                    onClick={handleReset}
                    className="adminReportdetails-filter-btn"
                  >
                    Reset
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>

          {/* view toggle */}
          <div className="adminReportdetails-filter-container">
            <div className="adminReportdetails-service-filters">
              <Button
                variant={viewMode === "table" ? "primary" : "outline-primary"}
                className="adminReportdetails-filter-btn"
                onClick={() => setViewMode("table")}
              >
                Table View
              </Button>
              <Button
                variant={viewMode === "graph" ? "primary" : "outline-primary"}
                className="adminReportdetails-filter-btn"
                onClick={() => setViewMode("graph")}
              >
                Graph View
              </Button>
            </div>
          </div>

          {/* content */}
          {loading && (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          )}
          {error && (
            <Alert variant="danger" className="adminReportdetails-error">
              {error}
            </Alert>
          )}
          {!loading && !error && summary.totalCount === 0 && (
            <p className="adminReportdetails-empty-text">No recharges found.</p>
          )}

          {!loading && !error && summary.totalCount > 0 && (
            <>
              {viewMode === "table" ? (
                <>
                  <Table
                    striped
                    bordered
                    hover
                    responsive
                    className="adminReportdetails-table"
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Servitor Name</th>
                        <th>Servitor ID</th>
                        <th>Mobile</th>
                        <th>Payment Method</th>
                        <th>Amount</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recharges.map((rc, idx) => {
                        const s = rc.Servitor;
                        const name = s
                          ? `${s.FirstName} ${s.LastName}`
                          : "N/A";
                        const method =
                          rc.paymentMethod || rc.PaymentMethod || "N/A";
                        const amount = Number(rc.amount) || 0;
                        const status = rc.status || "INIT";
                        const isPending = status === "INIT";

                        return (
                          <tr
                            key={
                              rc.Id || `${method}-${rc.created_at}-${idx}`
                            }
                          >
                            <td>
                              {idx + 1 + (meta.page - 1) * meta.limit}
                            </td>
                            <td>{name}</td>
                            <td>{s?.Id || "N/A"}</td>
                            <td>{s?.mobile || "N/A"}</td>
                            <td>{method}</td>
                            <td>{amount.toFixed(2)}৳</td>
                            <td>{formatDateTime(rc.created_at)}</td>
                            <td>{status}</td>
                            <td>
                              {/* ✅ NEW: compact icon actions */}
                              {/* <div className="adminReportdetails-actions">
                                <button
                                  type="button"
                                  className="adminReportdetails-action-btn action-view"
                                  onClick={() => handleOpenModal(rc)}
                                >
                                  <FaEye />
                                  <span>View</span>
                                </button>

                                {isPending && (
                                  <>
                                    <button
                                      type="button"
                                      className="adminReportdetails-action-btn action-approve"
                                      disabled={updatingId === rc.Id}
                                      onClick={() =>
                                        handleUpdateStatus(rc.Id, "VALID")
                                      }
                                    >
                                      <FaCheck />
                                      <span>
                                        {updatingId === rc.Id
                                          ? "Approving..."
                                          : "Approve"}
                                      </span>
                                    </button>

                                    <button
                                      type="button"
                                      className="adminReportdetails-action-btn action-reject"
                                      disabled={updatingId === rc.Id}
                                      onClick={() =>
                                        handleUpdateStatus(rc.Id, "FAILED")
                                      }
                                    >
                                      <FaTimesCircle />
                                      <span>
                                        {updatingId === rc.Id
                                          ? "Rejecting..."
                                          : "Reject"}
                                      </span>
                                    </button>
                                  </>
                                )}
                              </div> */}

                              <div className="adminReportdetails-actions">
    <button
      type="button"
      className="adminReportdetails-action-btn action-view"
      onClick={() => handleOpenModal(rc)}
      title="View details"
    >
      <FaEye />
    </button>

    {isPending && (
      <>
        <button
          type="button"
          className="adminReportdetails-action-btn action-approve"
          disabled={updatingId === rc.Id}
          onClick={() => openConfirmModal(rc, "approve")}
          title="Approve recharge"
        >
          <FaCheck />
        </button>

        <button
          type="button"
          className="adminReportdetails-action-btn action-reject"
          disabled={updatingId === rc.Id}
          onClick={() => openConfirmModal(rc, "reject")}
          title="Reject recharge"
        >
          <FaTimesCircle />
        </button>
      </>
    )}
  </div>
  
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>

                  <Pagination>
                    <Pagination.First
                      onClick={() => handlePageChange(1)}
                      disabled={meta.page === 1}
                    />
                    <Pagination.Prev
                      onClick={() => handlePageChange(meta.page - 1)}
                      disabled={meta.page === 1}
                    />
                    {getPageItems(meta.totalPages, meta.page).map(
                      (item, idx) =>
                        item === "start-ellipsis" ||
                        item === "end-ellipsis" ? (
                          <Pagination.Ellipsis key={item + idx} disabled />
                        ) : (
                          <Pagination.Item
                            key={item}
                            active={item === meta.page}
                            onClick={() => handlePageChange(item)}
                          >
                            {item}
                          </Pagination.Item>
                        )
                    )}
                    <Pagination.Next
                      onClick={() => handlePageChange(meta.page + 1)}
                      disabled={meta.page === meta.totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(meta.totalPages)}
                      disabled={meta.page === meta.totalPages}
                    />
                  </Pagination>
                  <div className="mt-2 text-muted adminReportdetails-results-text">
                    Showing {(meta.page - 1) * meta.limit + 1} to{" "}
                    {Math.min(meta.page * meta.limit, summary.totalCount)} of{" "}
                    {summary.totalCount} results
                  </div>
                </>
              ) : (
                <Row>
                  <Col md={6} className="mb-4">
                    <Card className="adminReportdetails-chart-card">
                      <Card.Body>
                        <h5 className="adminReportdetails-chart-title">
                          Recharge Amount — Month wise
                        </h5>
                        <div style={{ width: "100%", height: 320 }}>
                          <ResponsiveContainer>
                            <BarChart data={byMonthChart}>
                              <XAxis dataKey="month" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Bar
                                dataKey="amount"
                                name="Amount"
                                fill="#10b981"
                              />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={6} className="mb-4">
                    <Card className="adminReportdetails-chart-card">
                      <Card.Body>
                        <h5 className="adminReportdetails-chart-title">
                          Amount by Payment Method
                        </h5>
                        <div style={{ width: "100%", height: 320 }}>
                          <ResponsiveContainer>
                            <PieChart>
                              <Pie
                                data={byMethodChart}
                                dataKey="amount"
                                nameKey="method"
                                outerRadius={110}
                                label
                              >
                                {byMethodChart.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={
                                      COLORS[index % COLORS.length]
                                    }
                                  />
                                ))}
                              </Pie>
                              <Tooltip />
                              <Legend />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}
            </>
          )}
        </Card.Body>
      </Card>


      {confirmOpen && (
        <div className="adminReportdetails-confirm-backdrop">
          <div className="adminReportdetails-confirm-modal">
            <button
              type="button"
              className="adminReportdetails-confirm-close"
              onClick={closeConfirmModal}
              aria-label="Close"
            >
              <FaTimes size={14} />
            </button>

            <div
              className={`adminReportdetails-confirm-icon-wrap ${
                confirmType === "approve" ? "approve" : "reject"
              }`}
            >
              {confirmType === "approve" ? (
                <FaCheck />
              ) : (
                <FaTimesCircle />
              )}
            </div>

            <h3 className="adminReportdetails-confirm-title">
              {confirmType === "approve"
                ? "Approve this recharge?"
                : "Reject this recharge?"}
            </h3>

            <p className="adminReportdetails-confirm-text">
              {confirmType === "approve"
                ? "This will add the recharge amount to the servitor's balance."
                : "This will mark the recharge as rejected and will not change the servitor's balance."}
            </p>

            <div className="adminReportdetails-confirm-actions">
              <button
                type="button"
                className="adminReportdetails-confirm-btn confirm-primary"
                onClick={handleConfirmYes}
                disabled={updatingId === confirmRecharge?.Id}
              >
                {confirmType === "approve" ? "Yes, approve" : "Yes, reject"}
              </button>
              <button
                type="button"
                className="adminReportdetails-confirm-btn confirm-secondary"
                onClick={closeConfirmModal}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className="adminReportdetails-modal-backdrop" ref={modalRef}>
          {renderDetails()}
        </div>
      )}
    </Container>
  );
};

export default AmountRecharges;
